<script lang="ts">
    import { Datepicker } from "vanillajs-datepicker"
    import { _ } from "svelte-i18n"
    import { createEventDispatcher, onDestroy } from "svelte"
    import Icon from "../Icon.svelte"
    import { mdiCalendarPlus, mdiCalendarRemove } from "@mdi/js"
    import { clickIsOutsideDateModal, datepickerLanguage } from "./helper"

    // Externe Props (z.B. Initialwert und Platzhaltertext)
    export let dateValueString: string = ""
    export let dateValue: Date | null = null
    export let placeholder: string = $_("components.operationsFilter.until")
    export let className: string = ""
    export let dataCy = ""
    export let buttonInputAppend: boolean = false
    export let deactivateDateValueString = false

    if (!dateValue && dateValueString && !deactivateDateValueString) {
        dateValue = new Date(dateValueString)
    }

    $: {
        if (dateValue && !deactivateDateValueString) {
            try {
                dateValueString = new Date(dateValue.getTime() - dateValue.getTimezoneOffset() * 60000)
                    .toISOString()
                    .split("T")[0]
            } catch (e) {
                dateValueString = ""
                dateValue = null
            }
        } else {
            dateValueString = ""
        }
    }
    const dispatch = createEventDispatcher()

    let inputRef: HTMLInputElement
    let dateModal: HTMLElement
    let datepicker: typeof Datepicker | null = null

    // i18n-Konfiguration für den Kalender

    Datepicker.locales.en = datepickerLanguage

    function showDatepicker() {
        hideAllDatepickers()

        dateModal.style.display = "block"
        datepicker = new Datepicker(dateModal, {})
        if (dateValue) {
            datepicker.setDate(dateValue)
        }
        dateModal.addEventListener("changeDate", dateChangeListener)
        document.addEventListener("click", outsideClickListener)
    }

    function hideDatepicker() {
        dateModal.style.display = "none"
        datepicker?.destroy()
        datepicker = null
        dateModal.removeEventListener("changeDate", dateChangeListener)
        document.removeEventListener("click", outsideClickListener)
    }

    function dateChangeListener(e: any) {
        dateValue = new Date(e.detail.date)
        inputRef.value = dateValue.toLocaleDateString("de-DE")
        dispatch("update", dateValue)
        hideDatepicker()
    }

    function outsideClickListener(e: MouseEvent) {
        if (clickIsOutsideDateModal(e, dateModal)) hideDatepicker()
    }

    function hideAllDatepickers() {
        hideDatepicker()
    }

    $: if (inputRef && dateValue) {
        inputRef.value = dateValue.toLocaleDateString("de-DE")
    } else if (inputRef) {
        inputRef.value = ""
    }

    onDestroy(hideDatepicker)
</script>

<style>
    /* Styling so, dass der Input wie ein Standard‑date Widget aussieht */
    input.custom-date {
        width: 100%;
        padding: 8px;
        font-size: 16px;
        border: 1px solid #ccc;
        border-radius: 4px;
        box-sizing: border-box;
        background: #fff;
        color: #333;
        cursor: pointer;
    }

    input.custom-date:focus {
        outline: none;
        border-color: #007bff;
        box-shadow: 0 0 4px rgba(0, 123, 255, 0.5);
    }

    /* Der Kalender-Overlay-Container */
    .date-modal {
        position: absolute;
        display: none;
        z-index: 1000;
        background: #fff;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    }

    button.btn {
        position: absolute;
        top: 50%;
        right: 10px;
        transform: translateY(-50%);
        display: flex;
    }

    button.input-append {
        border: 0px;
    }
</style>

<div>
    <!-- Das Input-Feld im Aussehen eines date-Inputs -->
    <div style="position: relative;">
        <input
            type="text"
            class="custom-date {className}"
            {placeholder}
            bind:this="{inputRef}"
            on:focus="{showDatepicker}"
            readonly
            data-cy="{dataCy}"
        />
        <button
            data-cy="custom-date-picker-icon"
            class=" {buttonInputAppend ? 'input-append' : 'btn transparent icon'} {dateValue ? 'dateset' : ''}"
            on:click="{(e) => {
                e.stopPropagation()
                e.preventDefault()
                hideAllDatepickers()
                if (dateValue) {
                    dateValue = null
                    inputRef.value = ''
                } else showDatepicker()
            }}"
        >
            <Icon path="{dateValue ? mdiCalendarRemove : mdiCalendarPlus}" width="24px" height="24px" />
        </button>
    </div>

    <div id="dateModal2" class="date-modal" bind:this="{dateModal}"></div>
</div>
